import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { IntroSection } from "@/components/landing/IntroSection";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { StationNetwork } from "@/components/landing/StationNetwork";
import { TechSection } from "@/components/landing/TechSection";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView(), 50);
    }
  }, [hash]);
  return (
    <div className="bg-[#F7F7F2] text-[#202522]" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <IntroSection />
        <HowItWorks />
        <StationNetwork />
        <TechSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
